/*
 * View for inspecting and changing whether the KB automatically converts backslashes to frontslashes
 */

define(["marionette", "./template/convertBackslashTemplate.html"], function (
  Marionette,
  ConvertBackslashTemplate,
) {
  var ConvertBackslashView = {};

  ConvertBackslashView.convertBackslashView = Marionette.ItemView.extend({
    template: ConvertBackslashTemplate,
    modelEvents: {
      sync: "render",
    },
    textboxes: {},
    triggers: {
      "click #chkConvertBackslash": "toggle:backslash",
    },
  });

  return ConvertBackslashView;
});
